<template lang="html">
	<div class="recommendMod">
		<img :src="`${pagebase}/static/img/recommend/bg.jpg`" alt="" class="newBanner">
		<div class="recommendBtn">
			<img :src="`${pagebase}/static/img/recommend/btn.png`" alt="" @click="showMod">
		</div>

		<div class="alertMod" v-show="alertMod">
			<div class="alertContent">
				<div class="alertHead">
					<p>
						填写手机号注册电巢APP
					</p>
					<img src="../assets/image/closeBtn.png" alt="" @click="closeBtn">
				</div>
				<div class="cellPhoneNumber">
					<p>+86</p>
					<input type="text" name="" value="" @blur="fixScroll" placeholder="请输入您的手机号" v-model="phoneNum">
				</div>
				<div class="authCode">
					<input type="text" name="" value="" @blur="fixScroll" placeholder="验证码" v-model="authCodeNum">
					<p @click="cellPhoneBtn()"> {{content}} </p>
				</div>
				<div class="submitBtn">
					<div class="" @click="submitBtn()">
						确定
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {Base64} from '@/utils/base64.js';
	import { pagebase } from '@/utils/http.js';
	import utils from '@/utils/utils.js';
	import WxShare from '@/utils/wxshare';

	export default {
		data() {
			return {
				alertMod: false,
				phoneNum: '',
				authCodeNum: '',
				totalTime: 60,
				content: '发送验证码',
				pagebase: pagebase,
			}
		},
		mounted(){
			this.init();
		},
		methods: {
			init(){
				this.wxshare = new WxShare();
				this.wxshare.share({
					title: '电巢超多好课，邀你一起来学习！',
					desc: '电子产业链一站式数字化服务平台，电子人学习、工作、认证的孵化巢',
					link: window.location.href,
					imgUrl: pagebase + '/static/img/recommend/share_icon.jpg',
				})
			},
			fixScroll() {
				document.body.scrollTop = 0;
			},
			showMod() {
				this.alertMod = true;
			},
			closeBtn() {
				this.alertMod = false;
				this.phoneNum = '';
				this.authCodeNum = '';
			},
			submitBtn() {
				if (/^1[3|4|5|6|7|8]\d{9}$/.test(this.phoneNum)) {
					if (this.authCodeNum != '') {
						this.$http({
							url: '/task/recommendNew',
							method: 'post',
							params: {
								uid: Base64.decode(this.$route.query.a),
								phone_head: 86,
								phone: this.phoneNum,
								sms_code: this.authCodeNum,
							},
						}).then((res) => {
							if (res.code >= 0) {
								this.closeBtn();
								window.location.href = 'https://news.eda365.com/app/index.html';
							} else {
								utils.showMessage(res.msg);
							}
						});
					} else {
						utils.showMessage('验证码为空');
					}
				} else {
					utils.showMessage('手机号输入有误');
				}
			},
			cellPhoneBtn() {
				if (this.phoneNum == '') {
					utils.showMessage('手机号输入有误')
				} else {
					this.$http({
						url: '/Registered/getPhoneSmsCode',
						method: 'get',
						params: utils.cso({
							phone: this.phoneNum,
							phone_head: 86,
							type: 6,
							client: 'H5'
						})
					}).then((res) => {
						if (res.code == 0) {
							this.content = this.totalTime + 's'
							let clock = window.setInterval(() => {
								this.totalTime--
								this.content = this.totalTime + 's'
								if (this.totalTime < 0) {
									window.clearInterval(clock)
									this.content = '发送验证码'
									this.totalTime = 60
								}
							}, 1000)
						} else {
							utils.showMessage(res.msg);
						}
					})
				}
			},
		}
	}
</script>

<style lang="css" scoped>
.recommendMod {
	background-color: #eee;
}

.newBanner{
	width: 100%;
}

/* 弹框 */
.alertMod {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.6);
	display: flex;
	justify-content: center;
	align-items: center;
}

.alertContent {
	box-sizing: border-box;
	width: 284px;
	height: 220px;
	background-color: #fff;
	padding: 20px;
	border-radius: 20px;
}

.alertHead {
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 16px;
	font-weight: 600;
	color: #1D2023;
}

.alertHead img {
	width: 14px;
	height: 14px;
}

.cellPhoneNumber {
	height: 50px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 16px;
	color: #1D2023;
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.cellPhoneNumber p {
	width: 50px
}

.cellPhoneNumber input {
	height: 26px;
	font-size: 16px;
	width: 90%;
	border: none;
}

.authCode {
	height: 50px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 16px;
	color: #1D2023;
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.authCode input {
	width: 100px;
	font-size: 16px;
	height: 24px;
	border: none;
}

.authCode p {
	text-align: center;
	width: 70px;
	font-size: 12px;
	border: 1px solid #FBB6C0;
	color: #FBB6C0;
	padding: 4px 5px;
	border-radius: 4px;
}

.submitBtn {
	display: flex;
	justify-content: center;
	padding-top: 20px;
}

.submitBtn div {
	width: 130px;
	height: 40px;
	line-height: 40px;
	background: linear-gradient(to left, #E50101, #FE405A);
	font-size: 18px;
	text-align: center;
	color: #fff;
	border-radius: 20px;
	cursor: pointer;
}

.recommendBtn{
	margin-top: -80px;
	height: 70px;
	text-align: center;
}
.recommendBtn img{
	height: 100%;
	width: auto;
	object-fit: contain;
	cursor: pointer;
}
</style>
